module.exports = __webpack_public_path__ + "static/img/方案背景@2x.4fefc69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/方案背景@2x.png
// module id = oagD
// module chunks = 192